// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import { Language } from './lib/util/language.js'
import App from './App'
import router from './router'
import './router/before.js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'amfe-flexible'
import store from './store'
import { enumTool } from './lib/enum-tool'
import { Device } from './lib/device'
import 'vant/lib/index.css';
import './style.css'
import { loadCSS } from './lib/util/load-dynamic.js'
import { pcStyle } from './pop.js'
import { globalMixin } from './lib/globalMixin'
loadCSS(pcStyle)

// i18n
import { i18n } from './i18n'

// vant
import {Swipe,SwipeItem, DropdownMenu, DropdownItem, Icon, Collapse, CollapseItem } from 'vant';

Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Icon);
Vue.use(Swipe)
Vue.use(SwipeItem)

Vue.config.productionTip = false
Vue.use(ElementUI)

Vue.prototype.$enum = enumTool
Device.getDevice()
Vue.prototype.$isMobile = Device.isMobile()

// 全局混入
Vue.mixin(globalMixin)

Language.init().then(res => {
  new Vue({
    el: '#app',
    router,
    store,
    i18n,
    components: { App },
    template: '<App/>'
  })
})


// WEBPACK FOOTER //
// ./src/main.js